
import PropTypes from 'prop-types';

import useTranslations from "../../../providers/useTranslations";

import Product from '../../order/product'

function QuickBite(props) {
  const { detailColour, hasOrdering, optionsFirst, categories, isOffer } = props;

  const [product, setProduct] =React.useState(props.product)
  const [openProduct, setOpenProduct] =React.useState(false)
  const [displayPrice, setDisplayPrice] =React.useState(props.price)
  const [numItems, setNumItems] =React.useState(1)

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const IncrementItem = () => {
    setNumItems(numItems + 1);
  }


  useEffect(() => {
    setProduct(props.product)

  }, [props.product])

  const DecreaseItem = () => {
    //setQuantity(quantity - 1 );
    if (numItems > 1) {
      setNumItems(numItems - 1);
    }

    /*  if(quantity <= (min +1)) {

     }else {
         setState({ quantity: quantity - 1 });
       setValue({id:id,quantity: (quantity - 1 )});
     } */
  }

  const _productSize = (product) => {
    if (product.chosenSize) return (<span>({product.chosenSize})</span>)
    else if (product.size) return (<span>({product.size})</span>)
    return <></>
  }

  const getDisplayedBasePrice = () => {
    // if this is a combo product and the price is 0 then display a message
    if (isOffer) {
      return tr("Only available in the XooNoo mobile app")
    }
    if (displayPrice == 0) {
      return tr("Price may vary")
    }
    return `${props.priceUnit}${displayPrice}`
  }

  const totalHeader = () => {
    return <div className="col" style={{ padding: 0, margin: "5px 20px", minWidth: "145px" }}>
      <h6 className="mb-1 " onClick={() => {
        setOpenProduct(!openProduct)
      }}>{props.title} {props.showBadge ? <Badge variant={props.badgeVariant}>{props.badgeText}</Badge> : ""}</h6>


      <p className="mb-0 product-displayed-base-price">{getDisplayedBasePrice()}</p>
      <div className="row justify-content-center" style={{ margin: 0, marginTop: "5px", marginBottom: "5px", minWidth: "120px" }}>
        <span className="col-sm-12 col-md-6 " style={{ padding: "0px", marginLeft: "-40px" }}>
          <button variant="" onClick={DecreaseItem} className="btn-count"> <i className="icofont-minus" /> </button>
          <input className="count-number-input count-number" type="text" value={numItems} readOnly />
          <button variant="" onClick={IncrementItem} className="btn-count"> <i className="icofont icofont-plus" /> </button>
        </span>
        <span className="col-sm-12 col-md-5 product-total" style={{ padding: 0, paddingTop: "6px", fontSize: "15px" }}>
          Total: <b>${numItems * displayPrice}</b> {_productSize(product)}
        </span>
      </div>
    </div>
  }

  const carouselHeader = (assets) => {

    return (
      <div className="row product-header carousel-product-header business-assets-carousel">
        <div className="col-12 centered">
          <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
            {assets.map((a, index) => {
              return (
                <div className="item" key={`carouselImg_${index}`}>
                  <img src={a.url} style={{
                    maxHeight: 200,
                    minHeight: 200,
                    maxWidth: 600,
                  }} />
                </div>
              )
            })

            }

          </div>
        </div>
        {totalHeader()}
      </div>
    )

  }

  const assetHeader = (url) => {
    return <div className='row product-header asset-product-header' >
      <img onClick={() => {
        setOpenProduct(!openProduct)
      }}

      /* className="col-10 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8" */ src={url} alt={props.imageAlt}
        style={{ borderRadius: "8px", marginRight: "5px", padding: 0, marginBottom: "5px",
        maxHeight: 200,
        minHeight: 200,
        minWidth: 330,
        maxWidth: 600,
         }}
      />
      {totalHeader()}

    </div>
  }

  /*
   <img onClick={() => {
          setOpenProduct(!openProduct)
        }}

     src={props.image} alt={props.imageAlt}
      style={{ borderRadius: "8px", marginRight: "5px", padding: 0, marginBottom: "5px",
      maxHeight: 200,
      minHeight: 200,
      maxWidth: 600,
      boxFit: 'cover'


       }}
    />

  */

  const imageHeader = () => {
    return <div className='row product-header image-product-header' >
      {props.image ?
        <div onClick={() => {
          setOpenProduct(!openProduct)
        }}

      /* className="col-10 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8" */
          style={{ borderRadius: "8px", marginRight: "5px", padding: 0, marginBottom: "5px",
          maxHeight: 200,
          minHeight: 200,
          minWidth: 330,
          maxWidth: 600,
          backgroundSize: 'cover',
          backgroundImage: `url("${props.image}")`,
          backgroundOrigin: 'border-box',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'

           }}
        />
        :
        <div onClick={() => {
          setOpenProduct(!openProduct)
        }} className="mr-3"><i className={"icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
      }

      {totalHeader()}

    </div>
  }

  const productHeader = () => {
    if (product.Assets != null && product.Assets.length > 0) {
      // if only 1 asset use that as an image
      if (product.Assets.length == 1) {
        return assetHeader(product.Assets[0].url)

      }

      // otherwise create a carousel with the images
      return carouselHeader(product.Assets)
    }

    return imageHeader()
  }

  const openDivProduct = () => {
    return <div>
      {productHeader()}

      <Product product={product}
        categories={categories}
        value={numItems}
        isOffer={isOffer}
        onClose={() => setOpenProduct(false)}
        detailColour={detailColour}
        setDisplayTotal={(price, prod) => {
          setDisplayPrice(price)
          //console.log("setDisplayPrice with", price)
          if (prod) setProduct(prod)
        }}
        getDisplayedBasePrice={getDisplayedBasePrice}
        increment={IncrementItem}
        decrement={DecreaseItem}
        hasOrdering={hasOrdering} optionsFirst={optionsFirst} />

    </div>
  }

  const openMediaProduct = () => {
    return <div>
      <div className="media row product-header"   >
        {props.image ?
          <img onClick={() => {
            setOpenProduct(!openProduct)
          }}

          /* className="col-10 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8" */ src={props.image} alt={props.imageAlt}
            style={{ borderRadius: "8px", marginRight: "16px", height: "150px", padding: 0, marginBottom: "5px" }}
          />
          :
          <div onClick={() => {
            setOpenProduct(!openProduct)
          }} className="mr-3"><i className={" icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
        }
        <div  className="media col-10" style={{ padding: 0, margin: "5px", minWidth: "145px" }}>
          <h6 className="mb-1 " onClick={() => {
            setOpenProduct(!openProduct)
          }}>{props.title} {props.showBadge ? <Badge variant={props.badgeVariant}>{props.badgeText}</Badge> : ""}</h6>
          <p className="mb-0 product-displayed-base-price">{getDisplayedBasePrice()}</p>
          <div className="row justify-content-center" style={{ margin: 0, marginTop: "5px", marginBottom: "5px", minWidth: "120px" }}>
            <span className="col-sm-12 col-md-6 " style={{ padding: "0px", marginLeft: "-40px" }}>
              <button variant="" onClick={DecreaseItem} className="btn-count"> <i className="icofont-minus" /> </button>
              <input className="count-number-input count-number" type="text" value={numItems} readOnly />
              <button variant="" onClick={IncrementItem} className="btn-count"> <i className="icofont icofont-plus" /> </button>
            </span>
            <span className="col-sm-12 col-md-5 product-total" style={{ padding: 0, paddingTop: "6px", fontSize: "15px" }}>
              Total: <b>${numItems * displayPrice}</b> {_productSize(product)}
            </span>
          </div>
        </div>

      </div >

      <Product product={product}
        categories={categories}
        value={numItems}
        isOffer={isOffer}
        onClose={() => setOpenProduct(false)}
        detailColour={detailColour}
        setDisplayTotal={(price, prod) => {
          setDisplayPrice(price)
          //console.log("setDisplayPrice with", price)
          if (prod) setProduct(prod)
        }}
        getDisplayedBasePrice={getDisplayedBasePrice}
        increment={IncrementItem}
        decrement={DecreaseItem}
        hasOrdering={hasOrdering} optionsFirst={optionsFirst} />

    </div>
  }

  const getProductDisplay = () => {
    if (openProduct) {
      return openDivProduct()
    }

    return <div className='media product-list-item' onClick={() => {
      setOpenProduct(!openProduct)
    }} >
      {props.image ?
        <img className={props.imageClass} src={props.image} alt={props.imageAlt} style={{ borderRadius: "50%", marginRight: "16px", height: "70px", width: "70px" }} />
        :
        <div className="mr-3"><i className={"icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
      }
      <div className="media">
        <h6 className="mb-1">{props.title} {props.showBadge ? <Badge variant={props.badgeVariant}>{props.badgeText}</Badge> : ""}</h6>
        <p className="text-gray mb-0">{getDisplayedBasePrice()}</p>
      </div>
    </div >
  }

  // if (openProduct)
  //console.log("quickbite openProduct with", product)

  return (
    <div className={"p-3 pr-4 border-bottom QuickBite " + props.itemClass}>

      <span className="float-right">
        <button className=' btn btn-outline-secondary' onClick={() => {
          setOpenProduct(!openProduct)
        }} size="sm">
          {openProduct ? 'X' : '+'}
        </button>
      </span>

      {getProductDisplay()}

    </div>
  );
}


QuickBite.propTypes = {
  itemClass: PropTypes.string,
  title: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  image: PropTypes.string,
  imageClass: PropTypes.string,
  showBadge: PropTypes.bool,
  badgeVariant: PropTypes.string,
  badgeText: PropTypes.string,
  price: PropTypes.number.isRequired,
  priceUnit: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  qty: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  getValue: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired
};
QuickBite.defaultProps = {
  itemClass: 'gold-members',
  imageAlt: '',
  imageClass: '',
  showBadge: false,
  price: '',
  priceUnit: '$',
  showPromoted: false,
  badgeVariant: 'danger'
}


export default QuickBite;